import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'

import { SocialShare } from './SocialShare'

export type ShareGroupProps = {
  title: string
  text: string
  url: string
  children: React.ReactNode
  buttonLabel?: string
}

export function ShareGroup({
  title,
  text,
  url,
  children,
  buttonLabel,
}: ShareGroupProps): React.ReactElement<ShareGroupProps> {
  return (
    <ShareGroupWrapper>
      {children}
      <SocialShare url={url} title={title} text={text} buttonLabel={buttonLabel} />
    </ShareGroupWrapper>
  )
}

const ShareGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${S.copy.Text1} {
    text-align: center;
    margin-bottom: 20px;
  }

  ${ds.SocialShare} {
    @media screen and (${ds.breakpoint.TABLET}) {
      display: flex;
      margin-bottom: 24px;
    }
  }

  ${ds.Button} {
    display: block;
    margin-top: 6px;
    margin-bottom: 20px;
    padding-left: 25%;
    padding-right: 25%;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-top: 40px;

    ${S.copy.Text1} {
      width: 290px;
    }

    ${ds.Button} {
      margin: 35px 0px;
    }
  }
`
